import { Moment } from 'moment-timezone';
import { useEffect, useState } from 'react';

export interface DateRangeProps {
  from: Moment | null;
  to: Moment | null;
}

interface UseDatePickerParams {
  dateRangeProps: DateRangeProps;
  onValueChange: (value: { from: Date | undefined; to: Date | undefined }) => void;
}

export const useDateRangePicker = (params: UseDatePickerParams) => {
  const { dateRangeProps, onValueChange } = params;

  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<DateRangeProps>(dateRangeProps);

  const [tempValue, setTempValue] = useState<DateRangeProps>(dateRangeProps);

  useEffect(() => {
    setValue(dateRangeProps);
  }, [dateRangeProps]);

  function toggle() {
    setIsOpen(!isOpen);
  }

  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  function onConfirmChange() {
    setValue(tempValue);
    onValueChange({
      from: tempValue?.from?.startOf('day').toDate(),
      to: tempValue?.to?.endOf('day').toDate()
    });
    setIsOpen(false);
  }

  function onTempChange(value: DateRangeProps) {
    setTempValue(value);
  }

  function onReset() {
    setTempValue({
      from: null,
      to: null
    });
  }

  return {
    value,
    tempValue,
    isOpen,
    toggle,
    open,
    close,
    onTempChange,
    onConfirmChange,
    onReset
  };
};
